import dayjs from "dayjs";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { auth } from "../../../../utils/auth";
import { formatCurrency, formatDateTime } from "../../../../utils/helpers";
import { request } from "../../../../utils/request";
import { buildNotasVentasParams, buildRecibosParams, calculateVentasSummaries, processFactura } from "../../print/cuadreUtils";


const PrintCuadreDiarioVendedor = () => {
    const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
    const desde = dayjs(queryParams.get("desde"));
    const hasta = dayjs(queryParams.get("hasta"));

	const { facturas, recibos, notasCredito, summaries, rindex } = useData();

	const user = auth.getUser();
	const sucursal = user.sucursales.filter(
		(suc) => suc.id === user.sucursalActual
	)[0];

	const valorTotalFacturasPagadas = facturas.reduce((acc, factura) => {
		return (
			acc +
			(factura.estado === "pagada" ? parseFloat(factura.total) : 0)
		);
	}, 0);
	const valorTotalFacturasPendientes = facturas.reduce((acc, factura) => {
		return (
			acc +
			(factura.estado === "pendiente" ? parseFloat(factura.por_cobrar) : 0)
		);
	}, 0);
	const valorTotalRecibos = recibos.reduce((acc, recibo) => {
		return (
			acc +
			(recibo.status === "cancelado" ? 0 : parseFloat(recibo.abono_total))
		);
	}, 0);
    const valorTotalNotasCredito = notasCredito.reduce((acc, notaCredito) => {
		return (
			acc +
			(notaCredito.estado === "cancelada" ? 0 : parseFloat(notaCredito.total))
		);
	}, 0);

    const vendedorId = queryParams.get("vendedor");
    let vendedor = {};
    if (vendedorId) {
        vendedor = facturas.find((factura) => factura.vendedor?.id === parseInt(vendedorId))?.vendedor;
    }

	return (
		<div id="main-container" className="container">
            <style>
                {`
                    @page {
                        size: 80mm auto;
                        margin: 0;
                    }

                    #main-container, body {
                        width: 72mm;
                        margin: 0 auto;
                        font-size: 8px;
                    }
                `}
            </style>
			<div className="row">
				<h3 className="col-md-12 text-center m-b-5" style={{fontSize: '14px'}}>
					Reporte Cuadre de Caja
				</h3>
				<div className="col-md-12 text-center">
					{sucursal.nombre} - {sucursal.direccion} •{" "}
					{desde
						? `${desde.format(
								"DD/MM/YYYY"
						  )} - `
						: ""}{" "}
					{hasta.format("DD/MM/YYYY")}
				</div>
                {vendedorId && (
                    <div className="col-md-12 text-center">
                        <strong className="mr-1">Vendedor:</strong> {vendedor?.nombre} {vendedor?.apellido}
                    </div>
                )}
			</div>
			<div className="row mt-3">
				<div className="col-12">
                    <h5 className="fw-700 w-100 text-center mb-2" style={{fontSize: '10px'}}>
						DETALLES DE CUADRE
					</h5>
					<table className="table mb-3">
                        <tr>
                            <th>Canceladas</th>
                            <th>Recibos</th>
                            <th>Facturas</th>
                        </tr>

                        <tr>
                            <td>
                                {formatCurrency(summaries.canceladas)}
                            </td>
                            <td>
                                {formatCurrency(
                                    valorTotalRecibos
                                )}
                            </td>
                            <td>
                                {formatCurrency(summaries.pagada)}
                            </td>
                        </tr>

                        <tr>
                            <th>Notas Crédito</th>
                            <th>Total Ingresos</th>
                            <th>Total Facturado</th>
                        </tr>

                        <tr>
                             <td>
                                {formatCurrency(valorTotalNotasCredito)}
                            </td>
                            <td>
                                {formatCurrency(
                                    summaries.pagada + valorTotalRecibos
                                )}
                            </td>
                            <td>
                                {formatCurrency(
                                    summaries.facturado
                                )}
                            </td>
                        </tr>
					</table>

					<h5 className="fw-700 w-100 text-center mb-2" style={{fontSize: '10px'}}>
						FORMAS DE PAGO
					</h5>
					<table className="table mb-3">
                        <tr>
                            <th>Efectivo</th>
                            <th>Tarjeta</th>
                            <th>Transferencia</th>
                        </tr>

                        <tr>
                            <td>
                                {formatCurrency(summaries.efectivo)}
                            </td>
                            <td>
                                {formatCurrency(summaries.tarjeta + summaries['tarjeta-debito'])}
                            </td>
                            <td>
                                {formatCurrency(summaries.transferencia)}
                            </td>
                        </tr>

                        <tr>
                            <th>Depósito</th>
                            <th>Cheque</th>
                            <th>Otro</th>
                        </tr>

                        <tr>
                            <td>
                                {formatCurrency(summaries.deposito)}
                            </td>
                            <td>
                                {formatCurrency(summaries.cheque)}
                            </td>
                            <td>{formatCurrency(summaries.otro)}</td>
                        </tr>
					</table>
				</div>
				<div className="col-12">
                    <h5 className="fw-700 w-100 text-center mb-2" style={{fontSize: '10px'}}>
						TÉRMINOS DE PAGO
					</h5>
					<table className="table mb-4 text-center" style={{tableLayout: 'fixed'}}>
						<thead>
							<tr>
								<th>Contado</th>
								<th>Crédito</th>
								<th>Contra Entrega</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
                                    {formatCurrency(summaries.contado)}
								</td>
								<td>
                                    {formatCurrency(summaries.credito)}
								</td>
								<td>
                                    {formatCurrency(summaries.contraEntrega)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<h5 className="fw-700 w-100" style={{fontSize: '12px'}}>Facturas</h5>
            <div className="row">
                {facturas.map((factura) => {
                    const marca = rindex.indexOf(factura.id) > -1 ? '(RI)' : false;
                    const cheque = factura.cheques?.length > 0 ? factura.cheques[0] : null;

                    return <div className="col-12 mb-1" key={`f-${factura.id}`}>
                        <table className="table border">
                            <tr>
                                <th className="text-center" colSpan={6}>{factura.numero_comprobante}</th>
                            </tr>
                            <tr>
                                <td className="fw-600">Tipo</td>
                                <td className="text-capitalize">{factura.tipo}</td>
                                <td className="fw-600">Cliente</td>
                                <td>
                                    {factura.cliente
										? `${factura.cliente.codigo ?? ''} - ${factura.cliente.nombre}`
										: ""}
                                    {cheque && (
                                        <div><small className="uppercase">Cheque:</small> {cheque.numero} | <small className="uppercase">Valor:</small> {formatCurrency(cheque.monto)}</div>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="fw-600">Creación</td>
                                <td>
                                    {formatDateTime(factura.created_at)}
                                </td>
                                <td className="fw-600">Vencimiento</td>
                                <td>
                                    {new Intl.DateTimeFormat("es-ES").format(
										new Date(factura.fecha_vencimiento)
									)}
                                </td>
                            </tr>
                            <tr>
                                <td className="fw-600">Término</td>
                                <td className="text-capitalize">{factura.termino}</td>
                                <td className="fw-600">Tipo Pago</td>
                                <td>
                                    {['cancelada', 'pendiente'].indexOf(factura.estado) === -1 ? factura.tipo_pago : ''}
                                </td>
                            </tr>
                            <tr>
                                <td className="fw-600">Estado</td>
                                <td>
                                    <span>{factura.estado} {marca}</span>
                                </td>
                                <td className="fw-600">Total</td>
                                <td>
                                    {marca || ['cancelada', 'pendiente'].indexOf(factura.estado) > -1 ? (
                                        <del>{formatCurrency(factura.total)}</del>
                                    ) : formatCurrency(factura.total)}
                                </td>
                            </tr>
                        </table>
                    </div>;
                })}
            </div>
			<div className="row mb-3">
				<div className="col-4 text-left">
					<span style={{fontSize: '9px'}}>
						TOTAL FACTURAS: {facturas.length}
					</span>
				</div>

                <div className="col text-right">
                    <div style={{fontSize: '9px'}}>
                        TOTAL PENDIENTES: <strong>{formatCurrency(valorTotalFacturasPendientes)}</strong>&nbsp;
                        TOTAL PAGADAS: <strong>{formatCurrency(summaries.pagada)}</strong>
                    </div>
                </div>
			</div>

            <h5 className="fw-700 w-100" style={{fontSize: '12px'}}>Recibos de ingreso</h5>
            <div className="row">
                {recibos.map((recibo) => {
                    const facturasAfectadas = recibo.cuentas?.map(c => c.factura?.numero_comprobante);

                    return <div className="col-12 mb-1" key={`r-${recibo.id}`}>
                        <table className="table border">
                            <tr>
                                <th className="text-center" colSpan={6}>{recibo.numeracion}</th>
                            </tr>
                            <tr>
                                <td className="fw-600">Facturas afectadas</td>
                                <td>{<span>{facturasAfectadas.join('; ')}</span>}</td>
                                <td className="fw-600">Cliente</td>
                                <td>
                                    {`${recibo.cliente?.codigo ?? ''} - ${recibo.cliente?.nombre}`}
                                </td>
                            </tr>
                            <tr>
                                <td className="fw-600">Creación</td>
                                <td>
                                    {dayjs(recibo.created_at).format(
										"DD/MM/YYYY hh:mm"
									)}
                                </td>
                                <td className="fw-600">Deuda</td>
                                <td>
                                    {formatCurrency(recibo.deuda, "$")}
                                </td>
                            </tr>
                            <tr>
                                <td className="fw-600">Abono</td>
                                <td className="text-capitalize">{recibo.status === 'cancelado' ? (<del>{formatCurrency(recibo.abono_total, "$")}</del>) : (<span>{formatCurrency(recibo.abono_total, "$")}</span>)}</td>
                                <td className="fw-600">Restan</td>
                                <td>
                                    {formatCurrency(recibo.balance_total, "$")}
                                </td>
                            </tr>
                            <tr>
                                <td className="fw-600">Tipo de pago</td>
                                <td className="text-capitalize">
                                    <span>{recibo.tipo_pago}</span>
                                </td>
                                <td className="fw-600">Estado</td>
                                <td className="text-capitalize">
                                    {recibo.status}
                                </td>
                            </tr>
                        </table>
                    </div>;
                })}
            </div>
            <div className="row mb-3">
				<div className="col-5 text-left">
					<span style={{fontSize: '9px'}}>
						TOTAL RECIBOS: {recibos.length}
					</span>
				</div>

                <div className="col text-right">
                    <div style={{fontSize: '9px'}}>
                        VALOR TOTAL: <strong>{formatCurrency(valorTotalRecibos)}</strong>&nbsp;
                    </div>
                </div>
			</div>

            {notasCredito.length > 0 && (
                <>
                    <h5 className="fw-700 w-100" style={{fontSize: '12px'}}>Notas de Crédito</h5>
                    <div className="row">
                        {notasCredito.map((notaCredito) => {
                            return <div className="col-12 mb-1" key={`n-${notaCredito.id}`}>
                                <table className="table border">
                                    <tr>
                                        <th className="text-center" colSpan={6}>{notaCredito.numeracion}</th>
                                    </tr>
                                    <tr>
                                        <td className="fw-600">Facturas afectadas</td>
                                        <td>{notaCredito.factura?.numero_comprobante}</td>
                                        <td className="fw-600">Cliente</td>
                                        <td>
                                            {`${notaCredito.contacto?.codigo ?? ''} - ${notaCredito.contacto?.nombre}`}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="fw-600">Creación</td>
                                        <td>
                                            {dayjs(notaCredito.created_at).format(
                                                "DD/MM/YYYY hh:mm"
                                            )}
                                        </td>
                                        <td className="fw-600">Razón</td>
                                        <td>
                                            {notaCredito.razon}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="fw-600">Estado</td>
                                        <td className="text-capitalize">
                                            {notaCredito.estado}
                                        </td>
                                        <td className="fw-600">Total</td>
                                        <td>
                                            {formatCurrency(notaCredito.total)}
                                        </td>
                                    </tr>
                                </table>
                            </div>;
                        })}
                    </div>
                    <div className="row mb-3">
                        <div className="col-6 text-left">
                            <span style={{fontSize: '9px'}}>
                                TOTAL NOTAS DE CRÉDITO: {notasCredito.length}
                            </span>
                        </div>

                        <div className="col text-right">
                            <div style={{fontSize: '9px'}}>
                                VALOR TOTAL: <strong>{formatCurrency(valorTotalNotasCredito)}</strong>&nbsp;
                            </div>
                        </div>
                    </div>
                </>
            )}
		</div>
	);
};

const useData = () => {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);

	const [recibos, setRecibos] = useState([]);
	const [facturas, setFacturas] = useState([]);
	const [notasCredito, setNotasCredito] = useState([]);
	const [rindex, setRindex] = useState([]);
	const [summaries, setSummaries] = useState({
		efectivo: 0,
		tarjeta: 0,
		"tarjeta-debito": 0,
		transferencia: 0,
		deposito: 0,
		cheque: 0,
		otro: 0,
		pagada: 0,
		canceladas: 0,
        contado: 0,
        contraEntrega: 0,
        credito: 0,
	});

	const getFacturas = useCallback(() => {
		const searchString =
			location.search === ""
				? "?paginate=100000"
				: location.search + "&paginate=1000000";
		const hasta = dayjs(queryParams.get("hasta")).add(1, 'days');
		request(`facturas${searchString}`).then((res) => {
			setFacturas(res.data.map(factura => processFactura(factura, hasta)));
		});
	}, []);

	const getRecibos = useCallback(() => {
		const searchString = new URLSearchParams(buildRecibosParams(queryParams));
		request(`recibos-ingreso?${searchString.toString()}`).then((res) => {
			setRecibos(res.data);
		});
	}, []);

	const getNotasCredito = useCallback(() => {
		const searchString = new URLSearchParams(buildNotasVentasParams(queryParams));
		request(`notas-credito?${searchString.toString()}`).then((res) => {
			setNotasCredito(res.data.map(nota => {
                if (nota.estado === 'cancelada' && dayjs(nota.updated_at) > dayjs(queryParams.get("hasta"))) {
                    nota.estado = 'completada';
                }
                return nota;
            }));
		});
	}, []);

	useEffect(() => {
		const recibosIndex = [];
		recibos.forEach(recibo => recibo.cuentas.forEach(c => recibosIndex.push(c.factura_id)));
		setRindex(recibosIndex);

		const ventasSummaries = calculateVentasSummaries(facturas, recibos);

		let canceladas = 0;
		for (const recibo of recibos) {
			if (recibo.status === "cancelado") canceladas += recibo.abono_total;
		}
		const recibosSet = new Set(recibosIndex);
		for (const factura of facturas) {
			if (factura.estado === 'cancelada' && !recibosSet.has(factura.id)) {
				canceladas += factura.total;
			}
		}

		setSummaries({ ...ventasSummaries, canceladas });
	}, [recibos, facturas]);

	useEffect(() => {
		getFacturas();
		getRecibos();
        getNotasCredito();
	}, []);

	useEffect(() => {
		if (recibos.length === 0 && facturas.length === 0) return;

		const timeout = setTimeout(() => {
			window.print();
		}, 1000);

		return () => {
			clearTimeout(timeout);
		};
	}, [recibos]);

	return useMemo(
		() => ({
			facturas,
			recibos,
            notasCredito,
			summaries,
            rindex
		}),
		[facturas, recibos, summaries, rindex]
	);
};

export default PrintCuadreDiarioVendedor;
